import { createRouter, createWebHistory } from 'vue-router'
import LoginHeader from '../views/pubilc/loginPubilc.vue'
import Home from '../views/pubilc/home.vue'

const routerHistory = createWebHistory();


export const screenRouter = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
        children: [
            {
                path: "/newProjectList",
                name: "newProjectList",
                component: () => import("../views/new_project_list.vue"),
                meta: {
                    title: '中国长三角中心-项目库'   
                }
            }, {
                path: "/newProjectDetail",
                name: "newProjectDetail",
                component: () => import("../views/new_project_detail.vue"),
                meta: {
                    title: '中国长三角中心-项目库详情'
                }
            }
        ]
    },
    {
        path: '/preview',
        name: 'preview',
        component: () => import("../views/bp_preview.vue"),
    },
    {
        path: '/login',
        name: 'Login',
        component: LoginHeader,
        children: [{
            path: '/login',
            name: 'Login',
            component: () => import("../views/login.vue"),
            meta: {
                title: '中国长三角中心-登录'
            }
        }]
    },

];

const router = new createRouter({
    mode: 'history',
    history: routerHistory,
    routes: screenRouter,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

export default router